import { render, staticRenderFns } from "./DragAndDropList.vue?vue&type=template&id=8f93202e&scoped=true"
import script from "./DragAndDropList.vue?vue&type=script&lang=js"
export * from "./DragAndDropList.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropList.vue?vue&type=style&index=0&id=8f93202e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f93202e",
  null
  
)

export default component.exports